import { render } from "./DataFieldInput.vue?vue&type=template&id=5c661e56&scoped=true"
import script from "./DataFieldInput.vue?vue&type=script&lang=js"
export * from "./DataFieldInput.vue?vue&type=script&lang=js"

import "./DataFieldInput.vue?vue&type=style&index=0&id=5c661e56&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c661e56"]])

export default __exports__